import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  // styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
  }

  homeSliderOptions = {
    // margin: 30,
    nav: true,
    navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
    responsiveClass: true,
    dots:false,
    autoWidth:false,
    autoplay:true,
    loop:true,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      600: {
        items: 1,
        nav: false
      },
      1000: {
        items: 1,
        nav: false
      },
      1200: {
        items: 1,
        nav: true
      }
    }
  }

  homeSlides = [
    {
      image: "./assets/images/slide-1.jpg",
      slideTitle:'This is title 1',
      content:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s',
      ctaLabel:'About',
      ctaUrl:'/about'
    },
    {
      image: "./assets/images/slide-2.jpg",
      slideTitle:'This is title 2',
      content:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s',
      ctaLabel:'Contact Us',
      ctaUrl:'/contact-us'
    },
    {
      image: "./assets/images/slide-3.jpg",
      slideTitle:'This is title 3',
      content:'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s',
      ctaLabel:'Projects',
      ctaUrl:'/projects/ongoing'
    }
  ]

  carouselOptions = {
    margin: 30,
    nav: true,
    navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
    responsiveClass: true,
    dots:false,
    autoWidth:false,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      600: {
        items: 2,
        nav: false
      },
      1000: {
        items: 4,
        nav: false
      },
      1200: {
        items: 4,
        nav: true
      }
    }
  }

  productOptions = {
    margin: 30,
    nav: true,
    navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
    responsiveClass: true,
    dots:false,
    autoWidth:false,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      600: {
        items: 2,
        nav: false
      },
      1000: {
        items: 4,
        nav: false
      },
      1200: {
        items: 4,
        nav: true
      }
    }
  }

  products = [
    {
      image: "./assets/images/product-1.jpg",
      name:"Roshni solar panel 180 watt / 12 volt mono crystalline",
      warranty:"25 Years*",
      originalPrice:"12,500",
      offerPrice:"7,500",
      reviews:21,
      discount:40
    },
    {
      image: "./assets/images/product-2.jpg",
      name:"Roshni solar 2 panel stand (100-180 Watts)",
      warranty:"1 Year",
      originalPrice:"4000",
      offerPrice:"2000",
      reviews:30,
      discount:30
    },
    {
      image: "./assets/images/product-3.jpg",
      name:"Roshni solar panel 120 watt / 12 volt mono crystalline",
      warranty:"25 Years*",
      originalPrice:"8,500",
      offerPrice:"5000",
      reviews:12,
      discount:41
    },
    {
      image: "./assets/images/product-4.jpg",
      name:"Roshni solar panel 340 watt / 24 volt mono crystalline",
      warranty:"25 Years*",
      originalPrice:"25,500",
      offerPrice:"12,000",
      reviews:18,
      discount:52
    },
    {
      image: "./assets/images/product-2.jpg",
      name:"Roshni solar 2 panel stand (100-180 Watts)",
      warranty:"1 Year",
      originalPrice:"4000",
      offerPrice:"2000",
      reviews:30,
      discount:30
    },
    {
      image: "./assets/images/product-1.jpg",
      name:"Roshni solar panel 180 watt / 12 volt mono crystalline",
      warranty:"25 Years*",
      originalPrice:"12,500",
      offerPrice:"7,500",
      reviews:21,
      discount:40
    },
    {
      image: "./assets/images/product-4.jpg",
      name:"Roshni solar panel 340 watt / 24 volt mono crystalline",
      warranty:"25 Years*",
      originalPrice:"25,500",
      offerPrice:"12,000",
      reviews:18,
      discount:52
    },
    {
      image: "./assets/images/product-3.jpg",
      name:"Roshni solar panel 120 watt / 12 volt mono crystalline",
      warranty:"25 Years*",
      originalPrice:"8,500",
      offerPrice:"5000",
      reviews:12,
      discount:41
    }
    
  ];

}
